import React from "react";
import { Clock3, CheckCircle2, ShieldCheck, GraduationCap, UserSquare2 } from "lucide-react";

const cards = [
  {
    key: "pendingHq",
    label: "Yêu cầu cấp mới",
    sub: "Chờ duyệt chuyên môn",
    icon: Clock3,
    className: "bg-amber-50 text-amber-700 border-amber-100",
  },
  {
    key: "pendingMgmt",
    label: "Chờ duyệt cấp 2",
    sub: "Chờ duyệt lãnh đạo",
    icon: CheckCircle2,
    className: "bg-blue-50 text-blue-700 border-blue-100",
  },
  {
    key: "issuedTotal",
    label: "Đã cấp tổng",
    sub: "Đã duyệt cấp 2",
    icon: ShieldCheck,
    className: "bg-red-50 text-red-700 border-red-100",
  },
  {
    key: "issuedStudents",
    label: "Đã cấp học viên",
    sub: "Theo chứng nhận đã cấp",
    icon: GraduationCap,
    className: "bg-violet-50 text-violet-700 border-violet-100",
  },
  {
    key: "issuedTeachers",
    label: "Đã cấp giáo viên",
    sub: "Theo chứng nhận đã cấp",
    icon: UserSquare2,
    className: "bg-emerald-50 text-emerald-700 border-emerald-100",
  },
];

export default function CertificateTopDashboard({ loading = false, stats, visibleKeys }) {
  const valueOf = (k) => Number(stats?.[k] || 0);
  const shown = visibleKeys?.length
    ? cards.filter((c) => visibleKeys.includes(c.key))
    : cards;

  return (
    <div className="mb-4" data-tour="certificates-top-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-2.5 md:gap-3">
        {shown.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.key}
              className={`rounded-2xl border px-3 py-2.5 md:px-4 md:py-3 shadow-sm ${card.className}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <Icon size={14} className="shrink-0 opacity-90" />
                    <p className="text-[10px] md:text-[11px] font-black uppercase tracking-wide leading-tight">
                      {card.label}
                    </p>
                  </div>
                  <p className="mt-1 text-[9px] md:text-[10px] font-semibold opacity-80 leading-tight">
                    {card.sub}
                  </p>
                </div>
                <span className="text-xl md:text-2xl font-black leading-none tabular-nums shrink-0">
                  {loading ? "…" : valueOf(card.key)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

